export default __webpack_public_path__ + "static/media/favicon-32x32.fc4d5a09.png";